var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyPlan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_87443",
    "data-name": "Group 87443",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.875,
    height: 24.592,
    viewBox: "0 0 16.875 24.592",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_87444",
    "data-name": "Group 87444"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275631",
    "data-name": "Path 275631",
    d: "M14.949,24.334H1.928A1.945,1.945,0,0,1,0,22.376V2.684A1.945,1.945,0,0,1,1.928.726h2.41a.481.481,0,1,1,0,.961H1.928a.983.983,0,0,0-.967,1V22.376a.982.982,0,0,0,.967,1H14.949a.982.982,0,0,0,.967-1V2.684a.983.983,0,0,0-.967-1H12.537a.481.481,0,0,1,0-.961h2.412a1.944,1.944,0,0,1,1.926,1.958V22.376a1.944,1.944,0,0,1-1.926,1.958",
    transform: "translate(0 0.258)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275632",
    "data-name": "Path 275632",
    d: "M13.834,2.533V21.241H1.777V2.533H3.706V2.6a.916.916,0,0,0,.916.916h6.366a.916.916,0,0,0,.916-.916V2.533Z",
    transform: "translate(0.632 0.901)",
    fill: "#ffded7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275633",
    "data-name": "Path 275633",
    d: "M10.609,4.9H4.242a1.4,1.4,0,0,1-1.4-1.4V1.4A1.4,1.4,0,0,1,4.242,0h6.366A1.4,1.4,0,0,1,12,1.4V3.5a1.4,1.4,0,0,1-1.4,1.4M4.242.961a.434.434,0,0,0-.309.127.439.439,0,0,0-.127.309V3.5a.438.438,0,0,0,.437.437h6.366a.437.437,0,0,0,.435-.437V1.4a.436.436,0,0,0-.435-.437Z",
    transform: "translate(1.012)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275634",
    "data-name": "Path 275634",
    d: "M9.09,2.413H4.749a.481.481,0,0,1,0-.961H9.09a.481.481,0,0,1,0,.961",
    transform: "translate(1.518 0.516)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275635",
    "data-name": "Path 275635",
    d: "M3.809,7.288a.481.481,0,0,1-.343-.144l-.483-.493a.48.48,0,1,1,.686-.671l.14.141L5.395,4.5a.48.48,0,1,1,.686.672L4.152,7.144a.481.481,0,0,1-.343.144",
    transform: "translate(1.012 1.55)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275636",
    "data-name": "Path 275636",
    d: "M10.386,5.318H6.528a.481.481,0,0,1,0-.961h3.858a.481.481,0,0,1,0,.961",
    transform: "translate(2.151 1.55)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275637",
    "data-name": "Path 275637",
    d: "M10.386,6.771H6.528a.481.481,0,0,1,0-.961h3.858a.481.481,0,0,1,0,.961",
    transform: "translate(2.151 2.066)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275638",
    "data-name": "Path 275638",
    d: "M3.809,10.193a.481.481,0,0,1-.343-.144l-.483-.493a.48.48,0,1,1,.686-.671l.14.141L5.395,7.407a.48.48,0,1,1,.686.672l-1.929,1.97a.481.481,0,0,1-.343.144",
    transform: "translate(1.012 2.583)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275639",
    "data-name": "Path 275639",
    d: "M10.386,8.224H6.528a.481.481,0,0,1,0-.961h3.858a.481.481,0,0,1,0,.961",
    transform: "translate(2.151 2.583)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275640",
    "data-name": "Path 275640",
    d: "M10.386,9.676H6.528a.481.481,0,0,1,0-.961h3.858a.481.481,0,0,1,0,.961",
    transform: "translate(2.151 3.1)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275641",
    "data-name": "Path 275641",
    d: "M3.809,13.1a.481.481,0,0,1-.343-.144l-.483-.493a.48.48,0,1,1,.686-.671l.14.141,1.586-1.619a.48.48,0,1,1,.686.672l-1.929,1.97a.481.481,0,0,1-.343.144",
    transform: "translate(1.012 3.616)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275642",
    "data-name": "Path 275642",
    d: "M10.386,11.129H6.528a.481.481,0,0,1,0-.961h3.858a.481.481,0,0,1,0,.961",
    transform: "translate(2.151 3.616)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275643",
    "data-name": "Path 275643",
    d: "M10.386,12.581H6.528a.481.481,0,0,1,0-.961h3.858a.481.481,0,0,1,0,.961",
    transform: "translate(2.151 4.133)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275644",
    "data-name": "Path 275644",
    d: "M3.809,16a.481.481,0,0,1-.343-.144l-.483-.493a.48.48,0,1,1,.686-.671l.14.141,1.586-1.619a.48.48,0,1,1,.686.672L4.152,15.86A.481.481,0,0,1,3.809,16",
    transform: "translate(1.012 4.65)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275645",
    "data-name": "Path 275645",
    d: "M10.386,14.034H6.528a.481.481,0,0,1,0-.961h3.858a.481.481,0,0,1,0,.961",
    transform: "translate(2.151 4.65)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275646",
    "data-name": "Path 275646",
    d: "M10.386,15.487H6.528a.481.481,0,0,1,0-.961h3.858a.481.481,0,0,1,0,.961",
    transform: "translate(2.151 5.166)",
    fill: "#515255"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyPlan);
export default __webpack_public_path__ + "static/media/My_Plan.5cbeeb1b13c5ebc2ad15dc17df12d199.svg";
export { ForwardRef as ReactComponent };